/**
 * Created by Administrator on 2018/8/4 0004.
 */

import Vue from "vue"
import Vuex from 'vuex'
Vue.use(Vuex)
import users from './modules/users'

export default new Vuex.Store({
  modules: {
    users
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js